module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.0013,"color":"#198CDB","label":"<=0.13"},{"quantity":0.03,"color":"#91E3AD","label":"0.13 - 0.34"},{"quantity":0.06,"color":"#DEFFB0","label":"0.34 - 0.61"},{"quantity":0.01,"color":"#FFE68C","label":"0.61 - 1.0"},{"quantity":9,"color":"#FF9982","label":"1 - 1.66"},{"quantity":12,"color":"#FF4D30","label":"1.66 - 5.30"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_70_maize.json
// module id = lnVn
// module chunks = 171